export default {
  "header": {
    "hi": "Hi",
    "logout": "Logout",
    "profile": "Edit Profile",
    "admin": "Admin",
    "onboard": "Onboard Again"
  },
  "onboarding": {
    "title": "Welcome",
    "next": "Next",
    "previous": "Previous",
    "startLearning": "Start Learning",
    "finish": "Finish",
    "welcome": {
      "title": "Welcome to Grow With Us!"
    },
    "terms": {
      "title": "Terms & Conditions",
      "description": "Please read and accept Terms & Conditions.",
      "body": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>",
      "accept": "Accept"
    },
    "complete": {
      "imgAlt": "All done with onboarding",
      "title": "You are All Done!"
    }
  },
  "home": {
    "hero": {
      "text": "Imagina <br/> el futuro que <br/> quieres, luego <br/> créalo.",
      "play": "REPRODUCE EL VIDEO"
    },
    "takeCareChampion": "POR TAKECARE CHAMPIONS",
    "activation": {
      "title": "ACTIVACIÓN",
      "descriptionHtml": "Como <b> líder de la propiedad </b> o <b> TakeCare Champion </b>, se le encomienda guiar a los asociados en este viaje e inspirar su crecimiento. Hemos creado recursos para ayudar.",
      "action": "APRENDE MÁS"
    },
    "coaching": {
      "title": "ENTRENAMIENTO",
      "descriptionHtml": "El coaching ayuda a los asociados desde donde están hoy a donde quieren estar en el futuro.",
      "action": "APRENDE MÁS"
    },
    "pathway": {
      "section": {
        "learningHowToLearn": {
          "title": "Aprendiendo a aprender.",
          "description": "Comience aquí para comprender las habilidades y la mentalidad necesarias para el crecimiento y el aprendizaje continuo y de por vida."
        },
        "mindfulness": {
          "title": "Prepara tu mente.",
          "description": "Aprenda cómo traer <b> enfoque </b> a su vida, mejorar su bienestar mental y físico, y estar más alerta y relajado."
        },
        "resilience": {
          "title": "¿Estás preparado para el reto?",
          "description": "Aprenda a <b> recargar </b>, sea positivo y proactivo, actúe y piense de manera equilibrada y empatice con los demás."
        },
        "grow": {
          "title": "Continúa creciendo.",
          "description": "Esta colección de \"pathways\" está diseñada para ayudarlo a lograr un sentido de <b> Bienestar </b>, acelerar <b> Desarrollo personal </b> y obtener <b> Habilidades profesionales </b>."
        }
      }
    }
  },
  "pathway": {
    "playbook": {
      "back": "BACK"
    },
    "card": {
      "count": "%{topicCount} topics, %{assetCount} assets",
      "inThisPathway": "IN THIS PATHWAY:"
    },
    "category": {
      "Wellbeing": "WELLBEING",
      "Professional Skills": "PROFESSIONAL SKILLS",
      "Personal Development": "PERSONAL DEVELOPMENT"
    }
  },
  "playbook": {
    "item": {
      "takeaway": "TAKEAWAY",
      "setting": "SETTING",
      "setup": "SET UP",
      "technique": "TECHNIQUE",
      "back": "BACK"
    }
  },
  "activation": {
    "back": "BACK",
    "title": "Activating TakeCare Grow",
    "subtitle": "Below are materials and resources to help you activate and promote TakeCare Grow at your location!",
    "descriptionHtml": "<p><b>TakeCare Grow</b> is an online platform that helps associates grow their skillsets to thrive in their career and life. Mobile-capable, TakeCare Grow gives associates access to insights, exclusive tools and video-based learning resources anytime, anywhere.</p><p>As traditional jobs change and new roles emerge, TakeCare Grow unlocks the knowledge and expertise of associates to prioritize their continuous learning and prepare them for the future of work.</p><p>Download the library of materials to help you activate TakeCare Grow at your location. Materials are editable for you to customize as needed.</p>",
    "downloadTitle": "Downloadable Toolkit",
    "downloadSubtitle": "For Property Leaders and Champions"
  },
  "profile": {
    "title": "Edit Settings",
    "details": {
      "title": "Details"
    },
    "language": {
      "title": "Language",
      "instructions": "Please select your preferred <b>language</b>.",
      "unsupportedLanguage": "Your selected language is not available yet. Please check back soon."
    },
    "country": {
      "title": "Country",
      "instructions": "Please select your <b>country</b>."
    },
    "role": {
      "title": "Take Care Champion or Property Leader?",
      "instructions": "Are you a take care champion or a property leader?"
    }
  },
  "resource": {
    "tile": {
      "viewed": "Viewed",
      "completed": "Completed",
      "markComplete": "Mark Complete"
    },
    "types": {
      "display": {
        "book": "Book",
        "video": "Video",
        "app": "App",
        "activity": "Activity",
        "article": "Article",
        "course": "Course",
        "ebook": "eBook",
        "elearning": "E-Learning App",
        "mooc": "Course",
        "podcast": "Podcast",
        "tool": "Online Tool",
        "website": "Website",
        "tool-phone": "Phone App",
        "video-activity": "Video Activity",
        "videos": "Video",
        "videos-activity": "Video Activity"
      },
      "action": {
        "book": "Read",
        "video": "Watch Video",
        "app": "Go to App",
        "activity": "Go to Activity",
        "article": "Read Article",
        "course": "Go to Course",
        "ebook": "Read eBook",
        "elearning": "Go to E-Learning App",
        "mooc": "Go to Course",
        "podcast": "Listen to Podcast",
        "tool": "Go to Tool",
        "website": "View Website",
        "tool-phone": "Go to Phone App",
        "video-activity": "Go to Video Activity",
        "videos": "Watch",
        "videos-activity": "Go to Video Activity"
      }
    }
  },
  "admin": {
    "title": "Admin",
    "rights": {
      "title": "User Privileges",
      "description": "Assign specifc users admin and/or editor privileges.",
      "back": "Back to Admin",
      "getUser": {
        "title": "First get the user",
        "label": "Type in the username of the person you want to edit",
        "button": "Submit"
      },
      "updateUser": {
        "title": "User Privilages: %{userNameDisplay}",
        "button": "Update User Privileges"
      },
      "admin": {
        "title": "Make Admin",
        "canEditTitle": "Can Edit Privileges",
        "canEditDescription": "Can edit the privileges of other users (use this page).",
        "canMakeAdminTitle": "Can Make Others Admin",
        "canMakeAdminDescription": "Can give others the ability to edit privileges."
      },
      "lang": {
        "title": "Site Language",
        "canEditAllTitle": "Can Edit All Languages",
        "canEditAllDescription": "Can make updates all available site language labels."
      }
    },
    "lang": {
      "title": "Site Language",
      "description": "Manage translations for various languages for labels that appear on this website.",
      "back": "Back to Admin",
      "new": "Add New language",
      "table": {
        "language": "Language",
        "code": "Code",
        "actions": "Actions",
        "download": "Download CSV",
        "upload": "Update"
      },
      "add": {
        "title": "Add New Site Language Translations",
        "description": "Select the language you want to add and upload a CSV file with label translations.",
        "back": "Back to Site Language Admin",
        "language": "Select Language",
        "download": "Download CSV template file to edit",
        "upload": "Upload CSV file",
        "submit": "Submit",
        "success": "Language added successfully!"
      },
      "update": {
        "title": "Update Site Language Translations",
        "description": "Description",
        "back": "Back to Site Language Admin",
        "language": "Updating Language",
        "code": "Language Code",
        "download": "Download existing CSV file to edit",
        "upload": "Upload CSV file",
        "submit": "Submit",
        "success": "Language updated successfully!"
      }
    }
  },
  "forbidden": {
    "title": "Sorry!",
    "body": "Looks like you do not have access to this page!",
    "goHome": "Go to the Home Page"
  }
};



// WEBPACK FOOTER //
// ./src/lang/phrases_es.js